import { render, staticRenderFns } from "./SalesRecapPrintDetails_SalesRecap.vue?vue&type=template&id=fdccf2e0&"
import script from "./SalesRecapPrintDetails_SalesRecap.vue?vue&type=script&lang=js&"
export * from "./SalesRecapPrintDetails_SalesRecap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports